export const tooltipTheme = {
  baseStyle: {
    bg: 'secondary-950',
    p: '6px 8px',
    color: '#fff',
    borderRadius: '6px',
    zIndex: '999999',
    '[data-popper-arrow]': {
      display: 'none',
    },
  },
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
};
